export default __webpack_public_path__ + "static/media/dinner1.8a376871.png";